import { Pipe, PipeTransform, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserService } from '../services';

@Pipe({ name: 'userName' })
export class UserNamePipe implements PipeTransform {
    private userService = inject(UserService);

    public transform(value: string | null | undefined): Observable<string> {
        if (!value) return of('-');

        return this.userService.getByGID(value).pipe(
            map((user) => {
                if (user) {
                    return `${user.firstName} ${user.lastName}`;
                }
                return `GID: ${value}`;
            })
        );
    }
}
